import React from "react";
import "./Header.css";

function Header() {
  return (
    <>
      <div id="navbar">UNSCRAMBLE</div>
    </>
  );
}

export default Header;